import { NavLink, useLocation } from "react-router-dom";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import { useTranslation } from "react-i18next";
import {
    APP_FLAVOR_ORGAN,
    isBottomNavItemActive,
    resolveAppFlavor,
} from "../../helperData/appFlavor";
import usePanelBottomNav from "../../hooks/helperData/usePanelBottomNav";
import "./style.scss";

export default function PanelBottomNav() {
    const location = useLocation();
    const { t } = useTranslation();
    const isKeyboardOpen = useDetectKeyboardOpen();
    const flavor = resolveAppFlavor({
        pathname: location.pathname,
        search: location.search,
    });
    const items = usePanelBottomNav(flavor);

    if (!items.length || isKeyboardOpen) {
        return null;
    }

    const label =
        flavor === APP_FLAVOR_ORGAN
            ? t("AppNav.Organ.Name")
            : t("AppNav.User.Name");

    return (
        <nav
            className={`app-tabbar app-tabbar--${flavor}`}
            aria-label={label}
        >
            {items.map((item) => (
                <NavLink
                    key={item.key}
                    to={item.to}
                    end={Boolean(item.exact)}
                    className={() => {
                        const active = isBottomNavItemActive(
                            item,
                            location.pathname
                        );
                        return (
                            "app-tabbar__item" +
                            (item.featured ? " app-tabbar__item--scan" : "") +
                            (active ? " is-active" : "")
                        );
                    }}
                    aria-current={
                        isBottomNavItemActive(item, location.pathname)
                            ? "page"
                            : undefined
                    }
                >
                    {item.featured ? (
                        <span className="app-tabbar__scan-orb">
                            {item.icon}
                        </span>
                    ) : (
                        <span className="app-tabbar__icon">{item.icon}</span>
                    )}
                    <span className="app-tabbar__label">{item.label}</span>
                </NavLink>
            ))}
        </nav>
    );
}
